import styled from "styled-components";
import { Modal } from "react-bootstrap";
import "../styled.scss";

export const TalentAgencyManagerStyles = styled(Modal)`
  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
  }

  .modal-body {
    padding: 24px;
    height: calc(100vh - 177px);
    display: flex;
    flex-direction: column;
    gap: 24px;
    overflow: auto;

    .phone-field-wrapper {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    /* Chrome, Safari, Edge */
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type="number"] {
      -moz-appearance: textfield;
    }

    .access-level-wrapper {
      display: flex;
      flex-direction: column;
      gap: 8px;

      h5 {
        color: var(--Neutral-60);
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: -0.18px;
      }

      .radio-element {
        padding: 8px 0;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }

    .notes-wrapper {
      display: flex;
      flex-direction: column;
      padding: 8px 12px;
      border-radius: 12px;
      background: var(
        --Warning-8,
        linear-gradient(
          0deg,
          rgba(245, 159, 0, 0.08) 0%,
          rgba(245, 159, 0, 0.08) 100%
        ),
        #fff
      );

      h5 {
        overflow: hidden;
        color: var(--warning-100);
        text-overflow: ellipsis;
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: -0.18px;
      }

      p {
        color: var(--Neutral-80);
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: -0.12px;
      }
    }
  }

  .modal-footer {
    padding: 16px;
    height: 72px;
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    border-top: 1px solid var(--Neutral-8);

    button {
      width: 100%;
    }
  }
`;

export const RemoveTeamMemberStyles = styled(Modal)`
  .modal-header {
    border-bottom: none;
    padding: 0px !important;
    width: 100%;
  }

  .modal-body {
    color: var(--Neutral-100);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.14px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    gap: 8px;
  }
`;
